export enum Layout {
    SECURITY = 'SECURITY',
    GLOBAL_SOLUTION = 'GLOBAL_SOLUTION',
    GLOBAL_SOLUTION_WITHOUT_SIDEBAR = 'GLOBAL_SOLUTION_WITHOUT_SIDEBAR',
    EVENT = 'EVENT',
    MODULE = 'MODULE'
}
